import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

const UUID_V4ISH_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const businessIdGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const businessId = route.params["businessId"];

  if (!businessId || !UUID_V4ISH_REGEX.test(businessId)) {
    return router.createUrlTree(["/"]);
  }

  return true;
};
